export function externalDocumentFromDb(input) {
    return Object.assign(Object.assign({}, input), { createdAt: new Date(input.createdAt), identifyingData: input.identifyingData ? JSON.parse(input.identifyingData) : null, contentData: input.contentData ? JSON.parse(input.contentData) : null });
}
export function externalDocumentToDb(record) {
    return {
        id: record.id,
        flightDocumentId: record.flightDocumentId,
        flightId: record.flightId,
        legId: record.legId,
        notIdentified: record.notIdentified,
        contentKey: record.contentKey,
        _version: record._version,
        createdAt: record.createdAt.toISOString(),
        identifyingData: record.identifyingData ? JSON.stringify(record.identifyingData) : null,
    };
}
//# sourceMappingURL=externalDocuments.js.map